import { load } from "isomorphic-cookie";
var CORRELATION_ID_COOKIE = "lll-ecom-correlation-id";
var J_SESSION_ID_COOKIE = "JSESSIONID";
var USER_LOCALE_COOKIE = "UsrLocale";
var IS_LOGGED_IN_COOKIE = "isLoggedin";
var OKTA_SESSION_COOKIE = "okta-token-storage";
export var getCorrelationId = function(req) {
    return load(CORRELATION_ID_COOKIE, req, false) || "nonprod";
};
export var getJSessionId = function(req) {
    return load(J_SESSION_ID_COOKIE, req, false) || "nonprod";
};
export var getUsrLocale = function(req) {
    return load(USER_LOCALE_COOKIE, req, false) || "null";
};
export var getIsLoggedIn = function(req) {
    return !!load(IS_LOGGED_IN_COOKIE, req, false);
};
export var getOktaSession = function(req) {
    var _localStorage_getItem;
    var oktaSession = typeof window !== "undefined" ? (_localStorage_getItem = localStorage.getItem(OKTA_SESSION_COOKIE)) == null ? void 0 : _localStorage_getItem.length : load(OKTA_SESSION_COOKIE, req);
    return oktaSession > 50;
};
